import { Box, Divider, Typography } from "@mui/material";
import moment from "moment";
import dataConstant from "../constants/dataConstants";

const ImageWidget = ({
  id,
  label,
  schema,
  options = {},
  rawErrors = [],
  formContext,
}) => {
  const { labelText } = options;
  const submittedDate = formContext?.fullFormData?.createdAt
    ? moment
        .utc(formContext?.fullFormData.createdAt)
        .tz(dataConstant.centralAmericaTimeZone)
        .format(dataConstant.dateFormatUSFormat)
    : moment().tz(dataConstant.centralAmericaTimeZone).format(dataConstant.dateFormatUSFormat);
  const resolvedLabelText =
    typeof labelText === "string"
      ? labelText.replaceAll("{submittedDate}", submittedDate)
      : labelText;

  if (!schema?.image) {
    return null; // nothing to show if no image
  }

  return (
    <Box
      id={id}
      sx={{
        p: 0.5,
        textAlign: "center",
        maxWidth: "100%",
      }}
    >
      <img
        src={schema?.image}
        alt={label || ""}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
        />
        <Divider sx={{ borderBottomWidth: 2 }} />
        {resolvedLabelText && (
          <Typography
            variant="body2"
            color="text.primary"
            sx={{ mt: 1, display: "block" ,textAlign: "left" , pl: 1 , fontSize: "14px", whiteSpace:"pre-line" }}
          >
            {resolvedLabelText}
          </Typography>
        )}
    </Box>
  );
};

export default ImageWidget;
